module.exports = __webpack_public_path__ + "static/media/emojis_12.05238298.svg";